module.exports = function() {
  return new Worker(__webpack_public_path__ + "825c295e25bc415e4e30.worker.js");
};